<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/z1n9G1/tc-custom/9780062653710.jpg?1726715544933" alt="This image is the cover for the book Evermore, Everless"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Evermore, Everless
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>New York Times</i>–bestselling epic fantasy series continues as Jules confronts the girl who is both her oldest friend and greatest enemy.</b><br/><br/><b>Perfect for fans of Victoria Aveyard, Kiera Cass, and Kendare Blake.</b><br/><br/>Jules Ember was raised hearing legends of the ancient magic of the wicked Alchemist and the good Sorceress. But she has just learned the truth: She is the Alchemist, and Caro—a woman who single-handedly murdered the Queen and Jules’s first love, Roan, in cold blood—is the Sorceress.<br/><br/>The whole kingdom believes that Jules is responsible for the murders, and a hefty bounty has been placed on her head. And Caro is intent on destroying Jules, who stole her heart twelve lifetimes ago. Now Jules must piece together the stories of her past lives to save the person who has captured her heart in this one.<br/><br/><b>Praise for <i>Everless</i></b><br/><br/><b> “Sara Holland is a fierce storyteller. An intoxicating blend of blood, secrets, and haunting mythology, <i>Everless</i> gives new and terrifying meaning to the phrase running out of time.”—Stephanie Garber, <i>New York Times</i>–bestselling author of <i>Caraval</i></b><br/><br/><b>“Propelled by inventive lore and magic, Jules’s story is a heady, addicting page-turner—especially for readers who prize worldbuilding over romance. Utterly absorbing; a must for fans of Sarah J. Maas’s <i>Throne of Glass</i> . . . and its sequels.”—<i>Kirkus Reviews</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sara Holland
      </h2>
      
      <p class="authorDescription body article"><B>Sara Holland</B> grew up between small-town Minnesota and the countless fictional worlds of books. She graduated from Wesleyan University and worked in a tea shop, a dentist&#8217;s office, and a state capitol building before heading to New York to work in publishing. These days, she can be found exploring the city&#8217;s bookstores or finding new ways to put caffeine in her bloodstream. <I>Everless </I>is her debut novel and is followed by <I>Evermore</I>. Visit her online at www.sarahollandwrites.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c6bb968